module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_7042.aaab71da.png";